/**
 * Model reprezentujący formalny dokument księgowy (Fakturę).
 * Służy do wyświetlania historii rozliczeń i pobierania dokumentów
 * przez administratorów kliniki weterynaryjnej w panelu Dashboard.
 */
export class Invoice {


  /** Wewnętrzny identyfikator faktury w systemie. */
  public id: number;

  /** Rodzaj dokumentu księgowego.
   */
  public kind: string;

  /** Unikalny numer dokumentu, nadawany zgodnie z formatem księgowym
   */
  public number: string;


  /** Data sprzedaży / wykonania usługi. */
  public sellDate: string;

  /** Data wystawienia dokumentu. */
  public issueDate: string;

  /** * Ostateczny termin płatności (Due Date).
   */
  public paymentTo: string;

  /** Data faktycznego opłacenia faktury (jeśli została już uregulowana). */
  public paidDate: string;

  public paymentToKind: string;

  public paid: string;

  /** Aktualny status dokumentu w systemie.
   */
  public status: string;


  /** Pełna nazwa firmy wystawiającej fakturę. */
  public sellerName: string;
  /** Numer NIP sprzedawcy. */
  public sellerTaxNo: string;
  /** Ulica i numer lokalu sprzedawcy. */
  public sellerStreet: string;
  /** Kod pocztowy sprzedawcy. */
  public sellerPostCode: string;
  /** Miasto sprzedawcy. */
  public sellerCity: string;
  public sellerEmail: string;
  public sellerPhone: string;


  /** Pełna nazwa firmy nabywcy. */
  public buyerName: string;
  /** Ulica i numer lokalu nabywcy. */
  public buyerStreet: string;
  /** Kod pocztowy nabywcy. */
  public buyerPostCode: string;
  /** Miasto nabywcy. */
  public buyerCity: string;
  /** Adres e-mail nabywcy. */
  public buyerEmail: string;


  /** Tablica pozycji na fakturze (usługi, prowizje, opłaty abonamentowe)
   */
  public positions: any[];

}
